export interface CartItemDTO {
    id: string | null;
    productId: string| null;
    userId: string| null;
    quantity: number| null;
    price: number| null;
    name?: string| null;
    image? : string | null;
    sku? : string | null;
}

// CartItem.ts
export interface CartItem {
    id: string;
    productId: string;
    userId: string;
    quantity: number;
    price: number;
}

// Conversion function from DTO to model
export function toCartItem(dto: CartItemDTO): CartItem {
    return {
        id: dto.id,
        productId: dto.productId,
        userId: dto.userId,
        quantity: dto.quantity,
        price: dto.price
    };
}

export function createCartItemDTO(): CartItemDTO {
    return {
        id: null,
        productId : null,
        userId: null,
        quantity: 0,
        price: 0,
        name : '',
        image : '',
        sku : '',
    };
}